/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

export const videoIframeHolder = css({
  div: {
    display: 'flex',
    justifyContent: 'center',

    [MediaQueries.sm]: { height: '70vh' },
    [MediaQueries.md]: { height: '70vh' },
    [MediaQueries.lg]: { height: '70vh' },
  },
});
export const showVideo = css({
  iframe: {
    display: 'block',
  },
});

export const preloaderCss = css({
  marginTop: '100px',
  textAlign: 'center',
  '.lds-spinner': {
    color: 'official',
    display: 'inline-block',
    position: 'relative',
    width: '80px',
    height: '80px',
    transform: 'scale(0.5)',
  },
  '.lds-spinner div': {
    transformOrigin: '40px 40px',
    animation: 'lds-spinner 1.2s linear infinite',
  },
  '.lds-spinner div:after': {
    content: '" "',
    display: 'block',
    position: 'absolute',
    top: '3px',
    left: '37px',
    width: '6px',
    height: '18px',
    borderRadius: '20%',
    background: colorsPalette.black,
  },
  '.lds-spinner div:nth-child(1)': {
    transform: 'rotate(0deg)',
    animationDelay: '-1.1s',
  },
  '.lds-spinner div:nth-child(2)': {
    transform: 'rotate(30deg)',
    animationDelay: '-1s',
  },
  '.lds-spinner div:nth-child(3)': {
    transform: 'rotate(60deg)',
    animationDelay: '-0.9s',
  },
  '.lds-spinner div:nth-child(4)': {
    transform: 'rotate(90deg)',
    animationDelay: '-0.8s',
  },
  '.lds-spinner div:nth-child(5)': {
    transform: 'rotate(120deg)',
    animationDelay: '-0.7s',
  },
  '.lds-spinner div:nth-child(6)': {
    transform: 'rotate(150deg)',
    animationDelay: '-0.6s',
  },
  '.lds-spinner div:nth-child(7)': {
    transform: 'rotate(180deg)',
    animationDelay: '-0.5s',
  },
  '.lds-spinner div:nth-child(8)': {
    transform: 'rotate(210deg)',
    animationDelay: '-0.4s',
  },
  '.lds-spinner div:nth-child(9)': {
    transform: 'rotate(240deg)',
    animationDelay: '-0.3s',
  },
  '.lds-spinner div:nth-child(10)': {
    transform: 'rotate(270deg)',
    animationDelay: '-0.2s',
  },
  '.lds-spinner div:nth-child(11)': {
    transform: 'rotate(300deg)',
    animationDelay: '-0.1s',
  },
  '.lds-spinner div:nth-child(12)': {
    transform: 'rotate(330deg)',
    animationDelay: '0s',
  },
  '@keyframes lds-spinner': { '0%': { opacity: 1 }, '100%': { opacity: 0 } },
});
export const videoHolder = css({
  // position: 'absolute',
  // top: 0,
  // bottom: 0,
  // right: 0,
  // left: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginTop: '100px',

  iframe: {
    display: 'none',
  },

  '.close_btnsec': {
    width: '1080px',
    margin: '0 auto',
    [MediaQueries.lg]: { width: '970px' },
    [MediaQueries.md]: { width: '670px' },
    [MediaQueries.sm]: { width: '100%' },

    button: {
      position: 'relative',
      zIndex: 999999,
      display: 'flex',
      background: 'transparent',
      border: '0',

      cursor: 'pointer',
      width: '100%',
      float: 'right',
      maxWidth: '100px',
      padding: '15px 0px',

      [MediaQueries.sm]: {},
      [MediaQueries.xl]: {},

      i: {
        marginRight: '10px',
      },
    },
  },

  iframe: {
    height: '602px',
    width: '1058px',
    [MediaQueries.md]: {
      height: 'inherit',
      width: '600px',
    },

    [MediaQueries.lg]: {
      height: 'inherit',
      width: '900px',
    },

    [MediaQueries.sm]: {
      height: 'inherit',
      width: '100%',
    },
  },
});
